<template>
  <div>
    <div class="message-container" ref="allMessages">
      <div>
        <div v-for="message in messages" :key="message.id">
          <div
            :class="
              `${
                isMe(message.from_user_id) ? 'd-flex justify-end flex-wrap' : ''
              }`
            "
          >
            <div
              class="message"
              :class="`${isMe(message.from_user_id) ? 'self' : 'other'}`"
            >
              <div>
                <span class="message-sender">{{ displayFrom(message) }}</span>
              </div>
              <div>
                <span class="message-date">{{
                  formatRelative(parseISO(message.created_at))
                }}</span
                ><span class="message-sender-phone">{{
                  formatUSNumber(message.from_number)
                }}</span>
              </div>

              <div class="message-body">{{ message.body }}</div>
              <div
                v-for="(attachment, index) in message.attachments"
                :key="`image-${index}`"
              >
                <a
                  class="attachment-link"
                  v-if="attachment.type.includes('image')"
                  :href="`${apiUrl}/${attachment.url}`"
                  target="_blank"
                >
                  <v-img :src="`${apiUrl}/${attachment.url}`"></v-img
                ></a>
              </div>

              <div v-if="hasNonImageAttachments(message.attachments)">
                <br />
                <h3>Attachments</h3>
              </div>
              <div
                v-for="(attachment, index) in message.attachments"
                :key="index"
              >
                <a
                  v-if="!attachment.type.includes('image')"
                  :class="`${isMe(message.from_user_id) ? 'self' : 'other'}`"
                  :href="`${apiUrl}/${attachment.url}`"
                  target="_blank"
                  >{{ filename(attachment.url) }}</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-col class="text-center" cols="12">
      <div style="display: flex; padding-right: 20px">
        <v-text-field
          class="textbox"
          label="Message"
          dense
          solo
          outlined
          v-model="body"
          @keyup.enter="send()"
        ></v-text-field>
        <v-btn class="send-button" style="margin-right: 20px" @click="send()"
          >Send</v-btn
        >
      </div>
    </v-col>
  </div>
</template>

<script>
import formatRelative from "date-fns/formatRelative"
import parseISO from "date-fns/parseISO"
import User from "@/lib/user"
import eventMixin from "@/mixins/eventMixin"

export default {
  mixins: [eventMixin],
  props: { messages: Array },
  data: function() {
    return {
      body: "",
      apiUrl: process.env.VUE_APP_API_URL
    }
  },

  methods: {
    isMe(userId) {
      return userId == User.getUserId()
    },
    displayFrom(message) {
      return message.from_first_name ? message.from_first_name : message.from
    },
    parseISO(dateString) {
      return parseISO(dateString)
    },
    formatRelative(date) {
      return formatRelative(date, new Date())
    },
    send() {
      this.fireEvent("message:send", {
        userId: this.$route.params.id,
        body: this.body
      })
      this.body = ""
    },
    formatUSNumber(entry) {
      let formattedNumber = entry

      let match = entry
        .replace(/\D+/g, "")
        .replace(/^1/, "")
        .match(/([^\d]*\d[^\d]*){1,10}$/)

      if (match && match.length > 0) {
        match = match[0]

        const part1 = match.length > 2 ? `(${match.substring(0, 3)})` : match
        const part2 = match.length > 3 ? ` ${match.substring(3, 6)}` : ""
        const part3 = match.length > 6 ? `-${match.substring(6, 10)}` : ""

        formattedNumber = `${part1}${part2}${part3}`
      }

      return formattedNumber
    },
    filename(url) {
      return url.split("/").pop()
    },
    hasNonImageAttachments(attachments) {
      if (!attachments) {
        return false
      }
      return attachments
        .map(el => !el.type.includes("image"))
        .reduce((x, y) => x || y)
    },
    updated() {
      this.$refs.allMessages.scrollTop = this.$refs.allMessages.scrollHeight
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../scss/variables";
div.self {
  color: $dark-blue;
  border: 2px solid $dark-blue;
}
a.self {
  color: $dark-blue;
}
a.other {
  color: $orange;
}
div.other {
  color: $orange;
  border: 2px solid $orange;
}
div.message-container {
  overflow: hidden;
  padding-bottom: 25px;
  min-height: 75vh;
  max-height: 75vh;
  overflow-y: scroll;
}
div.v-image {
  border-radius: 10px;
}
div.message {
  border-radius: 15px;
  display: inline-block;
  margin: 5px;
  max-width: 90%;
  padding: 10px 22px 10px 22px;
  background-color: $off-white;
}
div.bottom {
  position: absolute;
  bottom: 0;
  width: 100%;
}
div.textbox {
  flex: 6;
  padding: 0 5px 0 0;
}
div.send-button {
  max-width: 20px;
  flex: 1;
  color: $orange;
}

.message-date {
  font-weight: 100;
  font-style: italic;
  font-size: 0.8em;
}

.message-sender {
  font-weight: 600;
  font-style: italic;
  font-size: 1.1em;
}

.message-sender-phone {
  font-weight: 100;
  font-style: italic;
  font-size: 0.8em;
  float: right;
}

.message-body {
  padding-top: 12px;
  border-top: 1px solid;
}
</style>
